import { useStorage } from '@vueuse/core';

export function usePreferedTimezone() {
  return useStorage('settings.timezone', 'UTC');
}

export function useEnableRemoteStats(page) {
  return useStorage(`settings.${page}.enableRemoteStats`, false);
}
